import { brandOverride } from '../clients/brandOverride';
import { CHALLENGE_DETAILS } from '../constants/challenge';

export const dynamicChallengeDetails = (totalDistance) => {
  const roundedTotalDistance = Math.floor(totalDistance);
  const stops = brandOverride().calculateDestination(roundedTotalDistance);
  const challengeDistance = brandOverride().challengeDistance;

  const calculateRemaining = () => {
    const remaining = Math.round(challengeDistance - roundedTotalDistance);

    return remaining <= 0 ? 0 : remaining;
  };

  return [
    ...CHALLENGE_DETAILS,
    {
      label: 'Completed',
      value: `${roundedTotalDistance} miles`,
    },
    {
      label: 'Remaining',
      value: `${calculateRemaining()} miles`,
    },
    {
      label: 'Currently',
      value: stops.current,
    },
    {
      label: 'Next stop',
      value: stops.next,
    },
  ];
};
